/* eslint-disable @typescript-eslint/no-explicit-any */
import { QuickMenu } from '@/components/QuickMenu'
import { useNotification, useStore } from '@/containers'
import { Footer } from '@/layouts/Footer'
import { Header } from '@/layouts/Header'
import HighlightServices from '@/layouts/HighlightServices'
import { type BannerList } from '@/types'
import dynamic from 'next/dynamic'
import { type ReactNode } from 'react'
const NotificationBar = dynamic(() => import('@/components/NotificationBar'), {
  ssr: false,
})
const OnDevelopment = dynamic(() => import('@/components/OnDevelopment'), {
  ssr: false,
})
const PopupShare = dynamic(() => import('@/components/Popup/PopupShare'), {
  ssr: false,
})
const ModalChooseLocation = dynamic(
  () => import('@/components/Popup/ModalChooseLocation'),
  {
    ssr: false,
  }
)
type IMainProps = {
  meta?: ReactNode
  children: ReactNode
  hideFooter?: boolean
  banner?: BannerList[]
  bgColor?: string
  bottomMenu?: any
  style?: any
  page?: string
  className?: string
}
const Main = (props: IMainProps) => {
  const { globalHeaderMenu } = useStore()
  const { systemConfig } = useNotification()
  return (
    <>
      {props.meta}
      <div className=' w-full text-dark-200 antialiased'>
        <Header page={props.page} />
        <div className='relative shadow-bottom'>
          <QuickMenu
            quickMenuData={globalHeaderMenu}
            className='container mx-auto'
          />
        </div>

        <NotificationBar />
        <main
          style={
            props.page === 'homepage'
              ? {
                  backgroundColor:
                    systemConfig?.homepageBgColor &&
                    systemConfig?.homepageBgColor,
                  backgroundImage:
                    systemConfig?.homepageBgImage &&
                    `url(${systemConfig?.homepageBgImage})`,
                  backgroundRepeat:
                    systemConfig?.homepageBgImage && `no-repeat`,
                  backgroundSize: systemConfig?.homepageBgImage && `100% auto`,
                  backgroundPosition:
                    systemConfig?.homepageBgImage && `bottom center`,
                  backgroundAttachment:
                    systemConfig?.homepageBgImage && `fixed`,
                }
              : props.style && props.style
          }
          className={`main-content bg-grey-100/30 pb-5 text-sm ${
            props.bgColor ? props.bgColor : ''
          } ${props.className ? props.className : ''}`}
        >
          <div
            className={`mainWrapper mx-auto w-full ${
              props.page === 'homepage' ? '' : 'container'
            }`}
          >
            {props.children}
            <HighlightServices />
          </div>
        </main>
        {!props.hideFooter && <Footer page={props?.page || ''} />}
        <OnDevelopment />
        <ModalChooseLocation />
        <PopupShare />
      </div>
    </>
  )
}

export { Main }
